import Styled from "@emotion/styled";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { useWidth } from "custom-hooks/use-width.hook";
import MobileMenu from "./components/MobileMenu";
import DesktopMenu from "./components/DesktopMenu";
import React, { useEffect } from "react";
import AuthDialogs from "../auth-dialogs";
import News from "@components/news";
import { useShowNews } from "shared/context/news.context";
import BannerBpd from "@components/news/BannerBpd";
import { Box, Grid } from "@mui/material";

function NavBar() {
  const width = useWidth();
  const { showNews } = useShowNews();

  return (
    <>
      <ContentNav showNews={showNews}>
        <MXAppBar>
          <MXToolbar>
            {["sm", "xs", "md"].includes(width) ? (
              <MobileMenu />
            ) : (
              <DesktopMenu />
            )}
          </MXToolbar>
          <AuthDialogs />
          {/* <News /> */}
        </MXAppBar>
      </ContentNav>
    </>
  );
}

export default NavBar;

export const Spacing = Styled.span`
  flex:1;
`;

const ContentNav = Styled.div<IContentNav>`
  // margin-top: 74px;
  ${({ showNews }) => showNews && "margin-top: 124px;"}
  @media screen and (max-width: 768px) {
    margin-top: 0px;
  }
`;

const MXAppBar = Styled(AppBar)`
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
`;

const MXToolbar = Styled(Toolbar)`
  display: flex;
  flex-direction: row;
  height: 73px;
  width: 100%;
  margin:0 auto;
  @media screen and (min-width:600px) {
      padding-left: 54px;
      padding-right: 0px;
  }
`;

interface IContentNav {
  showNews: boolean;
}
